import {Component, OnInit} from '@angular/core';
import {AuthAccessProvider} from '../core/core.auth';
import {MessageProvider} from '../service/message.service';
import {EquipmentService} from '../service/equipment.service';
import {BusyProvider} from '../service/busy.service';
import {AppConstants} from '../core/app.constants';
import {Router} from '@angular/router';
import {UserContext, BaseComponent, Equipment, EquipmentsRequest, EquipmentType, EquipmentUser, EquipmentUsersRequest} from '../core/core.component';
import {SelectItem} from 'primeng/primeng';
import {Message} from 'primeng/components/common/api';
import {ConfirmationService} from 'primeng/primeng';
import { environment } from '../../environments/environment';

declare var $: any;

@Component({
  selector: 'app-equipment-user',
  templateUrl: './equipment-user.component.html',
  styleUrls: ['./equipment-user.component.css'],
  host: { '(window:keydown)': 'shortcutHandler($event)' }
})
export class EquipmentUserComponent extends BaseComponent implements OnInit {

  static DIALOG_ID = 'EquipmentUserDialog';

  locale: any = AppConstants.ITA_CALENDAR_CONF;
  userContext: UserContext;
  loading = false;
  showEquipments = false;
  soloAttivi = true;

  canInsertEquipment = false;
  canAssignEquipment = false;

  equipmentTypes: SelectItem[] = [];
  equipmentTypesWithMac: number[] = [];

  equipments: Equipment[] = [];
  filteredEquipments: SelectItem[] = [];

  equipmentUsers: EquipmentUser[] = [];

  validationMessage: string = null;

  insert = true;
  insertEquipment = false;
  id: number = null;
  idEquip: number = null;
  dataInizioAssegnaz: Date = new Date();
  dataFineAssegnaz: Date = null;

  idTipo: number = null;
  desEquip: string = null;
  serialNumber: string = null;
  dataAcquisto: Date = null;
  codCespite: string = null;
  macAddress: string = null;

  msgs: Message[] = [];

  constructor(protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private equipmentService: EquipmentService,
    private busyProvider: BusyProvider,
    private confirmationService: ConfirmationService) {
    super(authAccess, router, messageProvider);
    this.messageProvider.clearAll();
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {
      this.canInsertEquipment = environment.CAN_USER_ADD_EQUIPMENT;
      this.canAssignEquipment = environment.CAN_USER_ASSING_EQUIPMENT;
    }
  }

  showHideEquipments() {
    this.showEquipments = !this.showEquipments;
    if (this.showEquipments && this.equipmentUsers.length == 0) {
      this.loadEquipmentUsers();
    }
  }

  loadEquipmentUsers() {
    this.equipmentUsers = [];
    this.loading = true;
    const request = new EquipmentUsersRequest();
    request.soloAttivi = this.soloAttivi;
    request.utenteCorrente = true;
    this.equipmentService.getEquipmentUsers(this.userContext.srmToken, request).subscribe(
      result => {
        this.loading = false;
        this.equipmentUsers = result.results;
      },
      error => {
        this.loading = false;
        this.handleError(error);
      });
  }

  loadEquipmentTypes() {
    if (this.equipmentTypes.length === 0) {
      this.equipmentService.getEquipmentTypes(this.userContext.srmToken).subscribe(
        result => {
          this.equipmentTypes.push({label: '', value: null});
          const types = result.types;
          for (let i = 0; i < types.length; ++i) {
            const current: EquipmentType = types[i];
            this.equipmentTypes.push({label: current.desc, value: current.id});
            if (current.flagMac) {
              this.equipmentTypesWithMac.push(current.id);
            }
          }
        },
        error => {
          this.handleError(error);
        });
    }
  }

  loadEquipments() {
    if (this.equipments.length === 0) {
      const request = new EquipmentsRequest();
      request.soloAttivi = true;
      request.nonAssegnati = true;
      this.equipmentService.getEquipments(this.userContext.srmToken, request).subscribe(
        result => {
          this.equipments = result.equipments;
          this.filterEquipments();
        },
        error => {
          this.handleError(error);
        });
    }
  }

  filterEquipments() {
    this.filteredEquipments = [];
    this.filteredEquipments.push({label: '', value: null});
    for (let i = 0; i < this.equipments.length; ++i) {
      const current = this.equipments[i];
      if (this.idTipo === null || current.idTipo === this.idTipo) {
        var serialNumberString:string = "";
        if (current.serialNumber != undefined && current.serialNumber !=null && current.serialNumber != ""){
          serialNumberString = ' (' + current.serialNumber + ')';
        }
        this.filteredEquipments.push({label: current.desc + serialNumberString, value: current.id});
      }
    }
  }

  openEquipmentDialog() {
    $('#' + EquipmentUserComponent.DIALOG_ID).modal({backdrop: 'static', keyboard: false});
  }

  closeEquipmentDialog() {
    $('#' + EquipmentUserComponent.DIALOG_ID).modal('hide');
  }

  newEquipmentUser() {
    this.loadEquipmentTypes();
    this.loadEquipments();
    this.insert = true;
    this.insertEquipment = false;
    this.id = null;
    this.idEquip = null;
    this.dataInizioAssegnaz = new Date();
    this.dataFineAssegnaz = null;
    this.desEquip = null;
    this.idTipo = null;
    this.serialNumber = null;
    this.dataAcquisto = null;
    this.codCespite = null;
    this.macAddress = null;
    this.openEquipmentDialog();
  }

  editEquipmentUser(current: EquipmentUser) {
    this.loadEquipmentTypes();
    this.loadEquipments();
    this.insert = false;
    this.id = current.id;
    this.idEquip = current.idEquip;
    this.dataInizioAssegnaz = new Date(current.dataInizioAssegnaz);
    this.dataFineAssegnaz = current.dataFineAssegnaz ? new Date(current.dataFineAssegnaz) : null;
    this.desEquip = current.desEquip;
    this.idTipo = current.idTipo;
    this.serialNumber = current.serialNumber;
    this.dataAcquisto = new Date(current.dataAcquisto);
    this.codCespite = current.codCespite;
    this.macAddress = current.macAddress;
    this.openEquipmentDialog();
  }

  showEquipmentData() {
    for (let i = 0; i < this.equipments.length; ++i) {
      const current = this.equipments[i];
      if (current.id === this.idEquip) {
        this.desEquip = current.desc;
        this.serialNumber = current.serialNumber;
        this.dataAcquisto = new Date(current.dataAcquisto);
        this.codCespite = current.codCespite;
        this.macAddress = current.macAddress;
        break;
      }
    }
  }

  newEquipment() {
    this.insertEquipment = true;
    this.id = null;
    this.idEquip = null;
    this.desEquip = null;
    this.serialNumber = null;
    this.dataAcquisto = new Date();
    this.codCespite = null;
    this.macAddress = null;
  }

  storeEquipmentUser() {
    this.messageProvider.clearAll();
    this.validationMessage = null;

    if (this.idTipo == null) {
      this.validationMessage = 'Selezionare il tipo';
      return;
    }
    if (this.idEquip == null && !this.insertEquipment) {
      this.validationMessage = 'Selezionare l\'attrezzatura';
      return;
    }
    if (this.dataInizioAssegnaz == null) {
      this.validationMessage = 'Inserire la data di assegnazione';
      return;
    }

    this.busyProvider.showBusyIndicator();
    if (this.insertEquipment) {
      this.equipmentService.insertEquipment(this.userContext.srmToken, this.desEquip, this.idTipo, this.serialNumber, this.dataAcquisto, this.codCespite, null, this.macAddress).subscribe(
        result => {
          this.busyProvider.hideBusyIndicator();
          this.msgs = [];
          this.msgs.push({severity: 'success', summary: 'OK', detail: 'Inserimento eseguito correttamente'});
          this.idEquip = Number(result.equipments[0].id);
          this.upsertEquipmentUser();
        },
        error => {
          this.busyProvider.hideBusyIndicator();
          this.handleError(error);
        });
    } else {
      this.upsertEquipmentUser();
    }
  }

  private upsertEquipmentUser() {
    this.equipmentService.upsertEquipmentUser(this.userContext.srmToken, this.insert, this.id, null, this.idEquip, this.dataInizioAssegnaz, this.dataFineAssegnaz).subscribe(
      result => {
        this.busyProvider.hideBusyIndicator();
        this.msgs = [];
        this.msgs.push({severity: 'success', summary: 'OK', detail: this.insert ? 'Inserimento eseguito correttamente' : 'Modifica eseguita correttamente'});
        this.loadEquipmentUsers();
        this.closeEquipmentDialog();
      },
      error => {
        this.busyProvider.hideBusyIndicator();
        this.handleError(error);
      });
  }

  removeEquipmentUser(equipmentUser: EquipmentUser) {
    this.confirmationService.confirm({
      key: 'deleteEquipmentUserConfirm',
      message: 'Eliminare ' + equipmentUser.desEquip + ' dalle proprie attrezzature?',
      accept: () => {
        this.equipmentService.deleteEquipmentUser(this.userContext.srmToken, equipmentUser.id).subscribe(
          result => {
            this.busyProvider.hideBusyIndicator();
            this.msgs = [];
            this.msgs.push({severity: 'success', summary: 'OK', detail: 'Cancellazione eseguita correttamente'});
            this.loadEquipmentUsers();
          },
          error => {
            this.busyProvider.hideBusyIndicator();
            this.handleError(error);
          });
      }
    });
  }

  shortcutHandler(event) { 
    if (event.keyCode == 27) { // ESC
        this.closeEquipmentDialog();
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/equipment-user/equipment-user.component.ts